import React, { HTMLAttributes } from "react";
import StepBlock from "../stepblock";

interface ISlideComponentOne {}

type TSlideComponentOneProps = ISlideComponentOne &
  HTMLAttributes<HTMLDivElement>;

const SlideComponentOne: React.FC<TSlideComponentOneProps> = (props) => {
  const { ...otherProps } = props;

  return (
    <div {...otherProps}>
      <StepBlock />

      {/* hints */}
      <div className="flex flex-row justify-end items-center text-right text-white my-5 gap-5">
        <div className="flex flex-col gap-2">
          <span className="text-xs laptop:text-sm font-bold">
            充電後請緊記將充電插頭放回原位！
          </span>
          <span className="text-xs">
            After charging, please remember to return the charging plug to its
            original position!
          </span>
        </div>
        <img
          src={require("../../../../assets/icons/reverse.png")}
          alt="reuse"
        />
      </div>
    </div>
  );
};

export default SlideComponentOne;
